module.exports = __webpack_public_path__ + "static/media/enviar-arquivo.3cc6075f.svg";